/**************************************************
 * Nombre:       Formacion_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import '@splidejs/react-splide/css';
import fondo from '../../../Recursos/fondos.png'
import {NEGRITA} from "../../../Constantes";
import iso from "../../../Recursos/iso_azul.svg";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Wass from "../../Dialogos/Dialogo_Wass";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const Formacion_Portada = ({item}) => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Wass, titulo: 'Inciar Conversación'})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                mt: -12,
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
            }}
        >

            <Dialogo/>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pt: 12}}
            >

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 11}}>


                    <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 12}}>
                                <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 600,
                                    color: '#fff'}}>
                                    {item.escuela}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                                <Typography sx={{
                                    fontSize: sCell ? 42 : 52,
                                    fontWeight: 600,
                                    fontFamily: NEGRITA,
                                    lineHeight: 1.1,
                                    textAlign: sCell ? 'center' : 'left',
                                    color: '#fff'
                                }}>
                                    {item.nombre}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 1}}>
                                <Typography sx={{
                                    fontSize: sCell ? 16 : 18,
                                    fontWeight: 400,
                                    textAlign: sCell ? 'center' : 'left',
                                    color: '#fff'
                                }}>
                                    {item.descripcion}
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 3}}>
                                <Button
                                    onClick={() => abrir({asunto: item.nombre})}
                                    color={'secondary'}
                                    startIcon={<img src={iso} style={{width: 24, height: 24, marginRight: 10}}/>}>
                                    Mas información
                                </Button>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 5}} sx={{justifyContent: 'flex-end', mt: 12}}>
                        <img src={item.img} width={sCell ? '100%' : '80%'}/>
                    </Grid>

                </Grid>


            </Grid>


        </Grid>
    )

}
export default Formacion_Portada

